import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { PageTitleProvider } from "./context/PageTitleContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import RestaurantList from "./components/RestaurantList";
import RestaurantDetail from "./components/RestaurantDetail";
import FoodsList from "./components/FoodsList";
import FoodDetail from "./components/FoodDetail";
import CuisineDetail from "./components/CuisineDetail";
import About from "./components/About";
import Contact from "./components/Contact";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import VerifyEmail from "./components/VerifyEmail";
import AddRestaurantForm from "./components/AddRestaurantForm";
import EditRestaurantForm from "./components/EditRestaurantForm";
import UserProfile from "./components/UserProfile";
import SavedPage from "./components/SavedPage";
import UserProfilePage from "./components/UserProfilePage";
import InvitePage from "./components/InvitePage";
import Notifications from "./components/Notifications";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import Faq from "./components/Faq";
import TermsAcceptanceModal from "./components/TermsAcceptanceModal";
import GuestReviewConflictModal from "./components/GuestReviewConflictModal";
import GuestDraftFailureModal from "./components/GuestDraftFailureModal";
import SessionExpiredBanner from "./components/SessionExpiredBanner";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <PageTitleProvider>
        <Router>
          <SessionExpiredBanner />
          <Navigation />
          <TermsAcceptanceModal />
          <GuestReviewConflictModal />
          <GuestDraftFailureModal />
          <Routes>
          <Route path="/" element={<RestaurantList />} />
          <Route path="/restaurants" element={<RestaurantList />} />
          <Route path="/foods" element={<FoodsList />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/saved" element={<SavedPage />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/profile/:userId" element={<UserProfilePage />} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/add-restaurant" element={<AddRestaurantForm />} />
          <Route path="/restaurant/:id/edit" element={<EditRestaurantForm />} />
          <Route path="/food-category/:categoryId/:slug?" element={<FoodsList />} />
          <Route path="/restaurant-category/:categoryId/:slug?" element={<RestaurantList />} />
          <Route path="/cuisine/:cuisineId/:slug?/restaurants" element={<RestaurantList />} />
          <Route path="/cuisine/:cuisineId/:slug?/foods" element={<FoodsList />} />
          <Route path="/cuisine/:cuisineId/:slug?" element={<CuisineDetail />} />
          <Route path="/restaurant/:id/:slug?" element={<RestaurantDetail />} />
          <Route path="/food/:id/:slug?" element={<FoodDetail />} />
        </Routes>
        <Footer />
        </Router>
      </PageTitleProvider>
    </AuthProvider>
  );
}

export default App;
